import { render } from "./commpany.vue?vue&type=template&id=60f83cb0"
import script from "./commpany.vue?vue&type=script&lang=js"
export * from "./commpany.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__